import { Component } from 'preact'
import Header from '../../header'
import AlertComponent from '../../ui-components/AlertComponent'
import Panel from '../../panel'
import InputGroup from '../../ui-components/InputGroup'
import Permissions from '../../category/control/Permissions'
import IncludeForStats from '../../category/control/IncludeForStats'
import Attachments from '../../category/control/Attachments'
import tracker from '../../../components/tracker/publish'
import axios from 'axios'

const eventTracker = (category) => {
  tracker.trackEvent('userevent', {
    type: 'Category Page Saved',
    category_title: category.title,
    category_type: 'knowledgebase',
    category_has_hero_image: category.heroImage !== null
  })
}

class KnowledgeBaseCategoryAdd extends Component {
  constructor (props) {
    super()
    this.state = {
      messageType: null,
      errors: [],
      category: props.category,
      showModal: false,
      showConfirmation: false,
      isLoading: false,
      showError: false,
      successMessage: ''
    }
    this.saveCategory = this.saveCategory.bind(this)
    this.setValue = this.setValue.bind(this)
    this.disableCreatePermissionsList = ['roles.not-activated', 'roles.requires-approval', 'roles.guest', 'roles.banned']
  }

  saveCategory () {
    const newData = JSON.parse(JSON.stringify(this.state.category))
    let errors = []

    if (!newData.title || newData.title === '') {
      errors.push('title')
    }
    if (!newData.description || newData.description === '') {
      errors.push('description')
    }
    if (errors.length) {
      this.setState({ errors })
      return
    }

    this.setState({ isLoading: true })

    axios.post('/platform/knowledge-base/new', newData, { params: { parentId: this.state.category.parentId } })
      .then((response) => {
        eventTracker(newData)
        let redirectTo = `${this.props.editLink}?id=${response.data.id}&success=true`
        window.location.assign(redirectTo)
      })
      .catch(() => {
        this.setState({ messageType: 'error', isLoading: false })
      })
  }

  setValue (key, value) {
    const category = Object.assign({}, this.state.category, { [key]: value })
    this.setState({ category, errors: [] })
  }

  componentDidMount () {
    this.setValue('permissions', [].concat(this.props.roles.main).concat(this.props.roles.custom))
  }

  render (props, state) {
    return (
      <div className='category-container category-add_container'>
        <Header
          title='Add category'
          cancelCallback={() => { window.location.assign(props.overviewLink) }}
          saveCallback={this.saveCategory}
          isLoading={this.state.isLoading}
        />
        <AlertComponent messageType={state.messageType} />
        <Panel title='Details'>
          <form>
            <InputGroup
              title='Title'
              placeholder='Add a title'
              type={'text'}
              error={state.errors.indexOf('title') !== -1 ? 'Please fill in this field' : ''}
              onChange={(e) => this.setValue('title', e.target.value)}
              value={state.category.title} />
            <InputGroup
              title='Description'
              placeholder='Add a description'
              error={state.errors.indexOf('description') !== -1 ? 'Please fill in this field' : ''}
              type={'text'}
              onChange={(e) => this.setValue('description', e.target.value)}
              value={state.category.description} />
            <IncludeForStats
              enable={state.category.includeForStats}
              onUpdate={(value) => this.setValue('includeForStats', value)}
            />
            <Attachments
              label='Hero image'
              className='hero-image'
              meta={
                <div>
                  <div>Hero image will be shown on top of the category page.</div>
                  <div>Maximum file size: 5MB. Allowed image types: .jpg, .png, .gif. We recommend a minimum of 2880*480px</div>
                </div>
              }
              isAttachmentSelected={state.category.heroImage}
              imageSrc={state.category.heroImage && state.category.heroImage.source_thumb}
              width={2880}
              height={480}
              onUpdate={(data) => this.setValue('heroImage', data)}
            />
            <Attachments
              label='Thumbnail image'
              className='thumbnail-image'
              meta={
                <div>
                  <div>Allowed image types: .jpg, .png, .gif. We recommend a minimum of 144*144px</div>
                </div>
              }
              isAttachmentSelected={state.category.thumbnailImage}
              imageSrc={state.category.thumbnailImage && state.category.thumbnailImage.source_thumb}
              width={144}
              height={144}
              onUpdate={(data) => this.setValue('thumbnailImage', data)}
            />
          </form>
        </Panel>
        <Panel title='Permissions'>
          <Permissions
            isKnowledgeBase
            mainCount={this.props.roles.main.length}
            disableCreatePermissionsList={this.disableCreatePermissionsList}
            permissions={state.category.permissions || []}
            onUpdate={(data) => this.setValue('permissions', data)}
          />
        </Panel>
      </div>
    )
  }
}

export default KnowledgeBaseCategoryAdd
